import m from 'mithril';
import selectVehicleModal from "./selectVehicle"
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'EDIT_DRIVER_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Edit Driver Details'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form', [
                      m('div.form-group', [
                        m('label', 'Driver Name:'),
                        m('input.form-control[type="text"][placeholder="Enter driver name"]', {
                          oninput: (e) => state.driverName = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Phone Number:'),
                        m('input.form-control[type="tel"][placeholder="Enter phone number"]', {
                          oninput: (e) => state.driverPhoneNumber = e.target.value,
                        }),
                      ]),
                    ]),
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-primary.btn-block[type="button"][class="w-100"]', {
                      onclick() {
                        modal.hide();
                        selectVehicleModal.show()
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
